import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  unReadNotificationCount: 0,
};

const commonSlice = createSlice({
  name: "commonSlice",
  initialState,
  //   reducer needs a map
  reducers: {
    setUnReadNotificationCount(state, action) {
      state.unReadNotificationCount = action.payload;
    },
    setUnreadRooms(state, action) {
      state.unreadRooms = action.payload;
    },
  },
});

export const { setUnReadNotificationCount, setUnreadRooms } =
  commonSlice.actions;

export default commonSlice.reducer;
